import React from 'react';
import { Accordion, InputLabel, Input } from '@weezevent/nacre';
import ColorPicker from '../../../../components/color-picker';
import { useTranslation } from 'react-i18next';
import css from '../../chart-list.module.css';

export default function ContingentForm({ contingent, index, onDelete, form, setForm, existingContingentColors }) {
    const { t } = useTranslation();
    const [showPicker, setShowPicker] = React.useState(false);

    const { color, name } = contingent;

    const handleColor = React.useCallback(
        color => {
            let contingent = form.contingents;
            contingent[index].color = color.hex;
            setForm('contingents', contingent);
        },
        [form.contingents]
    );

    const handleName = React.useCallback(
        value => {
            let contingent = form.contingents;
            contingent[index].name = value;
            setForm('contingents', contingent);
        },
        [form.contingents]
    );

    const uniqueColorsInForm = form.contingents.map(contingent => contingent.color).filter((v, i, a) => a.indexOf(v) === i);
    const displayErrorMessage = uniqueColorsInForm.length !== form.contingents.map(contingent => contingent.color).length;

    return (
        <Accordion
            key={index}
            classname={css['contingent-form__container']}
            disableToggle
            openByDefault
            title={
                <div className={css['category-delete-btn']}>
                    <span className={css['category-index']}>
                        {t('ticket.charts.contingents.list.contingent')} {index + 1}
                    </span>
                    {onDelete && index > 0 && (
                        <span className={css['category-delete']} onClick={() => onDelete(index)}>
                            {t('ticket.common.action.delete')}
                        </span>
                    )}
                </div>
            }
        >
            <InputLabel label={t('ticket.charts.contingents.new.contingent-name')} />
            <Input onChange={(e, { value }) => handleName(value)} value={name} placeholder={t('ticket.charts.contingents.new.contingent-name-placeholder')} />
            <div className={css['category-color-container']}>
                <div
                    className={css['category-color-picker']}
                    onClick={() => setShowPicker(!showPicker)}
                    style={{
                        backgroundColor: color || '#FFF'
                    }}
                />
                <span>{t('ticket.charts.contingents.new.color')}</span>
            </div>
            {(existingContingentColors?.includes(contingent.color) || displayErrorMessage) && <div className={css['color-error']}>{t('ticket.contingent.new.errorColor')}</div>}
            <ColorPicker show={showPicker} disableAlpha onChange={handleColor} onClickAway={() => setShowPicker(false)} color={color || '#FFF'} />
        </Accordion>
    );
}
